// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UploadStatusPage.css */

/* Custom tab styling */
.custom-tabs .nav-link {
    color: #6c757d;
    font-weight: 500;
    border: none;
    border-bottom: 3px solid transparent;
    padding: 12px 20px;
    transition: all 0.3s ease;
}

.custom-tabs .nav-link:hover {
    color: #145886;
    /* border-bottom-color: #145886; */
    background-color: transparent;
}

.custom-tabs .nav-link.active {
    color: #145886;
    border-bottom-color: #145886;
    background-color: transparent;
    font-weight: 600;
}

.custom-tabs .nav-tabs {
    border-bottom: 1px solid #dee2e6;
}

/* Table hover effects */
.table-hover tbody tr:hover {
    background-color: rgba(13, 110, 253, 0.04);
}

/* Badge styling */
.badge.rounded-pill {
    font-size: 0.75em;
    padding: 0.375em 0.75em;
}

/* Button loading state */
.btn:disabled {
    opacity: 0.6;
}

/* Checkbox styling */
.form-check-input:checked {
    background-color: #145886;
    border-color: #145886;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .custom-tabs .nav-link {
        padding: 10px 16px;
        font-size: 0.9rem;
    }
    
    .table-responsive {
        font-size: 0.875rem;
    }
    
    .btn-sm {
        font-size: 0.8rem;
        padding: 0.25rem 0.5rem;
    }
}

@media (max-width: 576px) {
    .custom-tabs .nav-link {
        padding: 8px 12px;
        font-size: 0.85rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BRC/UploadStatusPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,uBAAuB;AACvB;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,wBAAwB;AACxB;IACI,0CAA0C;AAC9C;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ","sourcesContent":["/* UploadStatusPage.css */\n\n/* Custom tab styling */\n.custom-tabs .nav-link {\n    color: #6c757d;\n    font-weight: 500;\n    border: none;\n    border-bottom: 3px solid transparent;\n    padding: 12px 20px;\n    transition: all 0.3s ease;\n}\n\n.custom-tabs .nav-link:hover {\n    color: #145886;\n    /* border-bottom-color: #145886; */\n    background-color: transparent;\n}\n\n.custom-tabs .nav-link.active {\n    color: #145886;\n    border-bottom-color: #145886;\n    background-color: transparent;\n    font-weight: 600;\n}\n\n.custom-tabs .nav-tabs {\n    border-bottom: 1px solid #dee2e6;\n}\n\n/* Table hover effects */\n.table-hover tbody tr:hover {\n    background-color: rgba(13, 110, 253, 0.04);\n}\n\n/* Badge styling */\n.badge.rounded-pill {\n    font-size: 0.75em;\n    padding: 0.375em 0.75em;\n}\n\n/* Button loading state */\n.btn:disabled {\n    opacity: 0.6;\n}\n\n/* Checkbox styling */\n.form-check-input:checked {\n    background-color: #145886;\n    border-color: #145886;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .custom-tabs .nav-link {\n        padding: 10px 16px;\n        font-size: 0.9rem;\n    }\n    \n    .table-responsive {\n        font-size: 0.875rem;\n    }\n    \n    .btn-sm {\n        font-size: 0.8rem;\n        padding: 0.25rem 0.5rem;\n    }\n}\n\n@media (max-width: 576px) {\n    .custom-tabs .nav-link {\n        padding: 8px 12px;\n        font-size: 0.85rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
